import React from "react";
import "./header.scss";
/* import Logo_mincomercio from "../../../assets/icons/LogoPresidenciaComercio.svg";
import img_govco from "../../../assets/icons/img-govco.svg"; */
import logo_sic from "../../../assets/icons/logo-sic-footer.png";

export default function Header() {
  return (
    <header class="bodygovcobase">
      <div class="govcobaseheader">
        <div class="govcobaseheader__container">
          <div class="govcobaseheader_container_maxwith">
            <a
              class="govcobaseheader_container_brand"
              href="https://www.gov.co"
              target="_blank"
              rel="noreferrer"
            >
              <img
                class="govcobaseheader_containerbrand_img"
                src="https://sedeelectronica.sic.gov.co/themes/custom/sictheme/logogovco.webp"
                alt="Logo Gov.co"
              />
            </a>
            <a
              class="govcobaseheader_container_link"
              href="https://www.gov.co"
              target="_blank"
              rel="noreferrer"
            >
              Ir a GovCo
            </a>
          </div>
        </div>
        <div class="govcobaseheader__logosbar">
          <div class="govcobaseheader_logosbar_maxwith">
            <div class="govcobaseheader_logosbar_presidencia">
              <a href="https://petro.presidencia.gov.co/" rel="home">
                <img
                  class="govcobaseheader_logosbarpresidencia_img"
                  src="https://sedeelectronica.sic.gov.co/themes/custom/sictheme/LogoPresidenciaComercio.webp"
                  alt="Logo presidencia"
                  width="148"
                />
              </a>
            </div>
            <div class="govcobaseheader_logosbar_superintendencia">
              <a href="https://www.sic.gov.co/" rel="home">
                <img
                  class="govcobaseheader_logosbar_superintendencia-img"
                  src={logo_sic}
                  alt="Logo superintendencia"
                  width="250"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
